"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ./~/_antd@3.18.2@antd/lib/button/style/index.js
// module id = 76
// module chunks = 7